const CHECK_AUTH = "CHECK_AUTH";
const GET_MAP_SERVERS = "GET_MAP_SERVERS";
const LOGOUT = "LOGOUT";

export {
    CHECK_AUTH,
    GET_MAP_SERVERS,
    LOGOUT
};